/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Scantocorrect_Name2Inputs */

const en_resources_scantocorrect_name2 = /** @type {(inputs: Resources_Scantocorrect_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scans to correct`)
};

const fr_resources_scantocorrect_name2 = /** @type {(inputs: Resources_Scantocorrect_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scans à corriger`)
};

const es_resources_scantocorrect_name2 = /** @type {(inputs: Resources_Scantocorrect_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escaneos a corregir`)
};

const de_resources_scantocorrect_name2 = /** @type {(inputs: Resources_Scantocorrect_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scans zu korrigieren`)
};

const nl_resources_scantocorrect_name2 = /** @type {(inputs: Resources_Scantocorrect_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scans te corrigeren`)
};

/**
* | output |
* | --- |
* | "Scans to correct" |
*
* @param {Resources_Scantocorrect_Name2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_scantocorrect_name2 = /** @type {((inputs?: Resources_Scantocorrect_Name2Inputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Scantocorrect_Name2Inputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_scantocorrect_name2(inputs)
	if (locale === "fr") return fr_resources_scantocorrect_name2(inputs)
	if (locale === "es") return es_resources_scantocorrect_name2(inputs)
	if (locale === "de") return de_resources_scantocorrect_name2(inputs)
	return nl_resources_scantocorrect_name2(inputs)
});
export { resources_scantocorrect_name2 as "resources.scanToCorrect.name" }